import Card from '../Card/Card'
import styles from './ConnectionError.module.css'
import Message from '../Message/Message';
import BrButton from '@govbr/react-components/lib/BrButton';
import * as mensagens from '../../common/Mensagens';
import { useHistory } from 'react-router-dom';
import configuration from '../../envConfig';
import {offlineIconSvg} from '../../common/base64images'

type InternetConnectionErrorProps = {
  refreshOnClick?: boolean;
  onClose?: () => void;
}

const InternetConnectionError = ({refreshOnClick = false, onClose}: InternetConnectionErrorProps) => {
  const history = useHistory();

  const handleClick = () => {
    history.replace("/home");
    if(onClose) {
      onClose();
    }
    
    if(refreshOnClick) {
      if (configuration.isCordova) {
        window.location.replace(window.location.href);
      } else {
        window.location.reload()
      }
    }
  }
  return (
    <>
      <Card className={styles.card}>
        <div className={styles.containerMensagem}>
          <img className={styles.imgMessage} src={offlineIconSvg} alt="Imagem" />
          <Message type={'error'} text={mensagens.MSG_ERRO_COMUNICACAO_INTERNET} />
          <div className={styles.botaoContainer}>
            <BrButton onClick={handleClick} className={styles.botao}>
              OK
            </BrButton>
          </div>
        </div>
      </Card>
    </>
  );
};

export default InternetConnectionError;
